import React from "react";
import { ClipLoader } from "react-spinners";

// Barre de recherche d'une liste : champ libre, bouton « Rechercher », bouton
// du panneau de filtres (`filtersLabel` : « Plus de filtres » quand des
// filtres principaux sont déjà dans la barre) et, sur une seconde ligne, les
// filtres principaux facultatifs (`inlineFilters`, voir InlineFilters) : le
// champ libre garde sa largeur quelle que soit la taille de l'écran. Un seul
// filtre principal tient sur la ligne du champ (`inlineFiltersLayout="ligne"`).

const SearchToolbar = ({
  id = "list-search",
  name = "terms",
  value = "",
  onChange,
  placeholder = "Rechercher…",
  label = "Recherche",
  hint = null,
  isLoading = false,
  isDirty = false,
  dirtyMessage = "Critères modifiés — lancez la recherche pour actualiser la liste.",
  submitLabel = "Rechercher",
  filtersPanelId = null,
  filtersOpen = false,
  onToggleFilters = null,
  activeFiltersCount = 0,
  filtersLabel = "Filtres",
  inlineFilters = null,
  inlineFiltersLayout = "dessous",
  children,
}) => {
  const hintId = `${id}-hint`;
  const enLigne = inlineFiltersLayout === "ligne";
  return (
    <div className={`search-toolbar${enLigne ? " search-toolbar--filtres-en-ligne" : ""}`}>
      <div className="search-toolbar__field">
        <label htmlFor={id} className="sr-only">
          {label}
        </label>
        <i className="fa fa-search" aria-hidden="true" />
        <input
          id={id}
          name={name}
          type="search"
          className="form-control"
          value={value || ""}
          onChange={onChange}
          placeholder={placeholder}
          autoComplete="off"
          aria-describedby={hint ? hintId : undefined}
        />
      </div>
      {enLigne && inlineFilters}
      <div className="search-toolbar__actions">
        <button
          type="submit"
          className="btn btn-primary search-toolbar__submit"
          aria-busy={isLoading || undefined}
          disabled={isLoading}
        >
          {isLoading ? (
            <>
              <ClipLoader size={16} color="#ffffff" />
              <span className="sr-only">Recherche en cours</span>
            </>
          ) : (
            <>
              <i className="fa fa-search mr-2" aria-hidden="true" />
              {submitLabel}
            </>
          )}
        </button>
        {onToggleFilters && (
          <button
            type="button"
            className="btn btn-filters"
            aria-expanded={filtersOpen}
            aria-controls={filtersPanelId || undefined}
            onClick={onToggleFilters}
          >
            <i className="fa fa-filter mr-2" aria-hidden="true" />
            {filtersLabel}
            {activeFiltersCount > 0 && (
              <span className="count-badge" data-testid="active-filters-count">
                {activeFiltersCount}
                <span className="sr-only"> filtres actifs</span>
              </span>
            )}
            <i className="fa fa-chevron-down btn-filters__chevron" aria-hidden="true" />
          </button>
        )}
        {children}
      </div>
      {hint && (
        <p id={hintId} className="search-toolbar__hint">
          {hint}
        </p>
      )}
      {!enLigne && inlineFilters}
      {isDirty && (
        <p className="search-toolbar__dirty" role="status">
          <i className="fa fa-info-circle" aria-hidden="true" />
          {dirtyMessage}
        </p>
      )}
    </div>
  );
};

export default SearchToolbar;
